/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyReturnBillPayment } from 'app/shared/model/pharmacy-return-bill-payment.model';
import { IPharmacyPaymentHistory } from 'app/shared/model/pharmacy-payment-history.model';
import { IPharmacyCredit } from 'app/shared/model/pharmacy-credit.model';
import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IPharmacySuppliers } from 'app/shared/model/pharmacy-suppliers.model';
import { TransactionType } from 'app/shared/model/enumerations/transaction-type.model';

export interface IPharmacyVendorPaymentTracker {
  id?: string;
  settledAmount?: number;
  transactionType?: keyof typeof TransactionType;
  addedById?: string | null;
  modifiedById?: string | null;
  active?: boolean;
  cursor?: number;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  returnPayment?: IPharmacyReturnBillPayment;
  purchasePayment?: IPharmacyPaymentHistory | null;
  parentCredit?: IPharmacyCredit;
  pharmacy?: IPharmacy;
  payedCredit?: IPharmacyCredit;
  supplier?: IPharmacySuppliers;
}

export const defaultValue: Readonly<IPharmacyVendorPaymentTracker> = {
  active: false,
};
